import {gql} from 'apollo-angular';

export const GET_PERSON_TITLES = gql`
  query GetPersonTitle {
    titles {
      id
      shortName
      description
    }
  }
`;
